import { Text } from '@mybridge/ui';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@mybridge/ui/modal';
import ImageUploader from 'v4/components/image-uploader';

export const ImageUploadModal = ({
  cropType,
  uploadCropedImg,
  handlePopups,
  ratio,
  ...props
}) => {
  const { t } = useTranslator();
  const direction = useDirection();
  return (
    <Modal size="2xl" {...props}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Text>{t('myDisk.upload') || "Upload"}</Text>
          <ModalCloseButton {...(direction === 'rtl') ? {left: '0.75rem', right: 'auto'} : {left: 'auto', right: '0.75rem'}} />
        </ModalHeader>
        <ModalBody>
          <ImageUploader
            cropType={cropType}
            uploadCropedImg={(val) => {
              uploadCropedImg?.(val);
              props?.onClose?.();
            }}
            onProfilePostData={()=>{<></>}}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
